export { default } from './AnimatedIcon'
